const LIST_TAGS = new Set(['UL', 'OL']);

function hasIndentClass(className: string): boolean {
  return className
    .split(/\s+/)
    .filter(Boolean)
    .some(token => token.startsWith('ql-indent-'));
}

function getListDepth(listItem: HTMLLIElement): number {
  let depth = 0;
  let currentElement: HTMLElement | null = listItem.parentElement;

  while (currentElement) {
    if (LIST_TAGS.has(currentElement.tagName)) {
      depth += 1;
    }

    currentElement = currentElement.parentElement;
  }

  // En Quill el primer nivel de lista no lleva indent.
  return Math.max(0, depth - 1);
}

function resolveListType(listItem: HTMLLIElement): 'ordered' | 'bullet' | null {
  const parentList = listItem.closest('ol, ul');

  if (!parentList) {
    return null;
  }

  return parentList.tagName === 'OL' ? 'ordered' : 'bullet';
}

/**
 * @description Rehidrata metadata de Quill para listas cuando backend/sanitización
 * elimina `data-list` y `ql-indent-*`, para evitar problemas de edición/selección.
 */
export function rehydrateQuillLists(html?: string): string {
  if (!html) {
    return '';
  }

  const parser = new DOMParser();
  const document = parser.parseFromString(html, 'text/html');
  const listItems = Array.from(document.body.querySelectorAll('li'));

  if (listItems.length === 0) {
    return html;
  }

  let hasMutations = false;

  listItems.forEach(item => {
    const listItem = item as HTMLLIElement;
    const listType = resolveListType(listItem);

    if (listType && !listItem.hasAttribute('data-list')) {
      listItem.setAttribute('data-list', listType);
      hasMutations = true;
    }

    const depth = getListDepth(listItem);
    if (depth > 0 && !hasIndentClass(listItem.className)) {
      listItem.classList.add(`ql-indent-${depth}`);
      hasMutations = true;
    }
  });

  return hasMutations ? document.body.innerHTML : html;
}
